import axios from '../http'

function query(data) {
    return axios.post('/sys/operating/query', data);
}

function list() {
    return axios.post('/sys/operating/list');
}

function find(data) {
    return axios.post('/sys/operating/find', data);
}

function get(id) {
    return axios.get('/sys/operating/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/operating/add', data);
}

function update(data) {
    return axios.post('/sys/operating/update', data);
}

function del(data) {
    return axios.post('/sys/operating/del', data);
}

export default {
    query,
    get,
    add,
    update,
    del,
    list,
    find
}